import React, { useMemo, useState } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export const Header: React.FC = () => {
  const navigate = useNavigate();
  const { user, isAuthenticated, logout: signOut } = useAuth();
  const [profileOpen, setProfileOpen] = useState(false);

  const displayName = user?.name || user?.email || 'Account';
  const initials = useMemo(() => {
    const source = user?.name || user?.email || 'A';
    return source
      .split(/\s|@/)
      .filter(Boolean)
      .slice(0, 2)
      .map((part) => part[0]?.toUpperCase())
      .join('');
  }, [user?.email, user?.name]);

  const logout = () => {
    signOut();
    setProfileOpen(false);
    navigate('/login');
  };

  return (
    <header className="relative z-10 bg-black shadow-[0_10px_30px_rgba(255,212,96,0.10)]">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-4 sm:px-6 lg:px-8">
        <Link to="/" className="flex items-center gap-4">
          <img src="/images/appvanz-logo.png" alt="Cinema Zone Logo" className="h-16 sm:h-20" />
          <div className="hidden sm:block">
            <div className="text-xl font-bold text-white">Cinema Zone</div>
            <div className="text-sm text-stone-300">Viu Distribution Partner</div>
          </div>
        </Link>
        <nav className="flex items-center gap-3 text-sm font-medium text-stone-300">
          <NavLink to="/" className={({ isActive }) => (isActive ? 'rounded-md bg-[#ffd460] px-3 py-2 text-stone-950' : 'px-1 hover:text-white')}>
            Browse
          </NavLink>
          <NavLink to="/rentals" className={({ isActive }) => (isActive ? 'rounded-md bg-[#ffd460] px-3 py-2 text-stone-950' : 'px-1 hover:text-white')}>
            Rentals
          </NavLink>
          {isAuthenticated ? (
            <div className="relative">
              <button
                className="grid h-10 w-10 place-items-center overflow-hidden rounded-full border-2 border-[#ffd460] bg-[#fff3c4] text-sm font-bold text-stone-950 shadow-sm"
                onClick={() => setProfileOpen((current) => !current)}
                aria-label="Open user menu"
                type="button"
              >
                {user?.avatarUrl ? <img src={user.avatarUrl} alt={displayName} className="h-full w-full object-cover" /> : initials}
              </button>
              {profileOpen && (
                <div className="absolute right-0 z-20 mt-3 w-64 rounded-lg border border-stone-800 bg-stone-300 p-2 text-sm shadow-lg">
                  <div className="px-3 py-2">
                    <p className="truncate font-semibold text-stone-950">{displayName}</p>
                    {user?.email && <p className="truncate text-stone-700">{user.email}</p>}
                  </div>
                  <div className="my-1 border-t border-stone-800" />
                  <Link className="block rounded-md px-3 py-2 text-stone-950 hover:bg-[#fff3c4]" to="/rentals" onClick={() => setProfileOpen(false)}>
                    My rentals
                  </Link>
                  <button className="mt-1 w-full rounded-md px-3 py-2 text-left text-stone-950 hover:bg-[#fff3c4]" onClick={logout} type="button">
                    Sign out
                  </button>
                </div>
              )}
            </div>
          ) : (
            <Link className="rounded-md bg-[#ffd460] px-3 py-2 text-stone-950 hover:bg-[#ffc83d]" to="/login">
              Login
            </Link>
          )}
        </nav>
      </div>
    </header>
  );
};
